<template>
    <section id="in-progress-deliveries">

        <!-- Header -->
        <section
            class="section-header"
            @click="toggleShowAll()"
        >
            <div class="header-text">
                <MaterialDesignIcon
                    className="truck-fast-outline"
                    hasRightMargin
                />
                <label>In Progress Deliveries</label>
            </div>
            <ButtonChevronFlippable :flipUp="showAll"/>
        </section>

        <!-- Expanded Area -->
        <section
            v-if="showAll"
            class="expanded-area"
        >

            <div
                v-if="inProgressDeliveryInfo.inFlight"
                class="in-flight-container"
            >
                <p>Looking for Deliveries in progress...</p>
                <b-loading :isFullPage="false" :active="inProgressDeliveryInfo.inFlight" />
            </div>

            <div v-if="hasNoDeliveriesToResume">
                <!-- TODO: This needs styling -->
                <p>Nothing is currently out for Delivery</p>
            </div>

            <ListDeliverySummary
                v-if="hasDeliveriesInProgress"
                :inProgressDeliveryList="inProgressDeliveryInfo.list"
            />

        </section>

    </section>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

// Api
import DeliveryApi from '@/api/DeliveryApi';

// Components
import MaterialDesignIcon from '@/components/base/MaterialDesignIcon';
import ButtonChevronFlippable from '@/components/base/ButtonChevronFlippable';
import ListDeliverySummary from './alreadyInProgressDeliveries/ListDeliverySummary';

export default {
    name: 'AlreadyInProgressDeliveries',
    components: {
        MaterialDesignIcon,
        ButtonChevronFlippable,
        ListDeliverySummary,
    },
    data() {
        return {
            showAll: false,

            /** @type { Object } */
            inProgressDeliveryInfo: {
                /** @type { Array } */
                list: [],
                /** @type { Boolean } */
                inFlight: true,
            },
        };
    },
    computed: {
        ...mapState( {
            jwtToken: ( state ) => state.User.jwtToken,
            userAccountId: ( state ) => state.User.accountId,
        } ),
        ...mapGetters( {
            websiteId: 'Website/id',
        } ),
        /** @returns { Boolean } */
        hasDeliveriesInProgress() {
            return this.inProgressDeliveryInfo.list.length > 0;
        },
        /** @returns { Boolean } */
        hasNoDeliveriesToResume() {
            return !this.inProgressDeliveryInfo.inFlight && !this.hasDeliveriesInProgress;
        },
    },
    mounted() {
        this.getInProgressDeliveries();
    },
    methods: {
        toggleShowAll() {
            this.showAll = !this.showAll;
        },

        async getInProgressDeliveries() {
            this.inProgressDeliveryInfo.inFlight = true;
            try {
                const { data } = await DeliveryApi.getInProgressDeliveries( {
                    jwtToken: this.jwtToken,
                    websiteId: this.websiteId,
                    userAccountId: this.userAccountId,
                } );
                this.inProgressDeliveryInfo.list = ( data.inProgressPicklists && data.inProgressPicklists.length && ( data.inProgressPicklists.length > 0 ) )
                    ? data.inProgressPicklists.map( ( picklist ) => ( {
                        ...picklist,
                        // Add refNum as a key
                        refNum: picklist.mailTransPicklist.refNum,
                        // Add a count so we can sort on the field
                        mailItemCount: ( picklist.mailItems && picklist.mailItems.length && ( picklist.mailItems.length > 0 ) )
                            ? picklist.mailItems.length
                            : 0,
                    } ) )
                    : [];
            } catch ( error ) {
                console.error( 'Error getting Deliveries already in progress', error );
            } finally {
                this.inProgressDeliveryInfo.inFlight = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">

#in-progress-deliveries {

}

.section-header {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    cursor: pointer;
}
.header-text {
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: underline;
}

.expanded-area {
    margin-top: 1rem;
}

.in-flight-container {
    position: relative;
    padding: 2rem;
}

.detailed-table {
    //
}

@include mixins-above(tablet) {
    .detailed-table {
        border: 1px solid gainsboro;
        border-radius: 4px;
    }

    /*[data-label="Actions"] {
        display: flex;
        >button {
            margin: auto 0 auto auto;
        }
    }*/
}
</style>
